import type { NonEmptyArray } from '@festina-life/core'
import cx from 'classnames'

import { borderStyles } from './borderStyles'

/**
 * Utility function to generate paper styles.
 */
export const paperStyles = ({
  borders,
  isFaded = false,
  ringColor,
  ringPosition = 'inset',
}: {
  borders?: NonEmptyArray<'bottom' | 'left' | 'right' | 'top' | 'all'>
  ringColor?: 'grey' | 'greyContrast' | 'primary' | 'error'
  ringPosition?: 'inset' | 'outset'
  isFaded?: boolean
} = {}) => {
  const isInsetRing = ringPosition === 'inset'
  return cx(
    isFaded
      ? 'bg-slate-100 dark:bg-slate-800'
      : 'bg-amaze-paper dark:bg-amaze-paperDark',
    ringColor &&
      cx(
        isInsetRing ? 'inset-ring' : 'ring',
        {
          grey: isInsetRing
            ? 'inset-ring-slate-200 dark:inset-ring-slate-700'
            : 'ring-slate-200 dark:ring-slate-700',
          greyContrast: isInsetRing
            ? 'inset-ring-slate-300 dark:inset-ring-slate-600'
            : 'ring-slate-300 dark:ring-slate-600',
          primary: isInsetRing ? 'inset-ring-primary-500' : 'ring-primary-500',
          error: isInsetRing
            ? 'inset-ring-error-300 dark:inset-ring-error-800'
            : 'ring-error-300 dark:ring-error-800',
        }[ringColor],
      ),
    borders && borderStyles,
    borders?.includes('all') && 'border',
    borders?.includes('bottom') && 'border-b',
    borders?.includes('left') && 'border-l',
    borders?.includes('right') && 'border-r',
    borders?.includes('top') && 'border-t',
  )
}
